/* eslint-disable react/no-array-index-key */

import { WagtailStreamfieldImage } from '@/types';
import Image from 'next/image';
import { addBaseUrl } from '@/utils/url';
import RawHtml from '@components/RawHtml';

interface Tiles {
  iconsvg: string | null;
  iconimage: WagtailStreamfieldImage | null;
  infotext?: string;
  tiletext?: string;
}

interface Props {
  title?: string;
  tiles: Tiles[];
}

function FeatureTiles(props: Props) {
  const { tiles, title } = props;
  return (
    <div className='streamfield featuretiles'>
      <h2>{title}</h2>
      <div className='featuretiles__wrapper'>
        {tiles.map((tile, index) => (
          <div className='featuretile' key={index}>
            <div className='featuretile__bgwrapper'>
              {tile.iconimage && !tile.iconsvg ? (
                <div className='card__iconwraper'>
                  <Image
                    src={addBaseUrl(tile.iconimage.file.src)}
                    alt={tile.iconimage.file.alt}
                    layout='intrinsic'
                    objectFit='contain'
                    className='featuretile__icon'
                    width='120'
                    height='120'
                  />
                </div>
              ) : null}

              {tile.iconsvg ? <RawHtml className='featuretile__icon' html={tile.iconsvg} /> : null}
              <div className='featuretile__text'>{tile.infotext ? tile.infotext : ''}</div>
            </div>
            <div className='featuretile__text--small'>{tile.tiletext ? tile.tiletext : ''}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FeatureTiles;
